import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class Renters {

    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }

    pg_renters_coverage(payload) {
        console.log(payload)

        //if(!this.fs.isBundle()) {
            this.fs.setDefaultEffectiveDate('in_renters_start_date', 1);
        //}
    }

    pg_renters_details(payload) {
        console.log(payload)
    }

    /* setDefaultEffectiveDate(days) {
        if (this.ctx.state.funnel.elements.in_renters_start_date.value == "") {
            let date = new Date()
            date.setDate(date.getDate() + days)
            const effectiveDate = Utils.formatDate(date)
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_renters_start_date', key: 'value', val: effectiveDate })
        }
    } */
}